import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { fetchWithRetry } from '../../util/sliceUtils';

const backendUrl = process.env.REACT_APP_BackendUrl;

const INTERSECTIONS_URL = backendUrl + '/intersections';

export const trafficInfraSlice = createSlice({
    name: 'trafficInfra',
    initialState: {
        intersections: {},
        intersectionsLoading: false,
        retryCount: 0,
    },
    reducers: {
        setIntersections: (state, action) => {
            state.intersections = action.payload;
            state.retryCount = 0;
        },
        setIntersectionsLoading: (state, action) => {
            state.intersectionsLoading = action.payload;
        },
        incrementRetryCount: (state) => {
            state.retryCount += 1;
        },
        resetRetryCount: (state) => {
            state.retryCount = 0;
        },
    },
});

export const {
    setIntersections,
    setIntersectionsLoading,
    incrementRetryCount,
    resetRetryCount,
} = trafficInfraSlice.actions;

// Retry thunk for manual retry from toast - this is what gets dispatched when clicking retry
export const retryIntersections = () => (dispatch) => {
    console.log('Manually retrying intersections...');
    dispatch(resetRetryCount());
    dispatch(getIntersections(true));
};

export const getIntersections = (forceRetry = false) => {
    return fetchWithRetry({
        fetchFn: () => axios.get(`${INTERSECTIONS_URL}`, { headers: {} }),
        actions: {
            setData: setIntersections,
            setLoading: setIntersectionsLoading,
            incrementRetry: incrementRetryCount,
        },
        selectors: {
            selectRetryCount: selectRetryCount,
            selectLoading: selectIntersectionsLoading,
        },
        retryActionName: 'RETRY_INTERSECTIONS',
        errorMessagePrefix: 'Failed to load intersections',
        retryThunk: getIntersections,
    }, forceRetry);
};

export const selectIntersections = state => state.trafficInfra.intersections;
export const selectIntersectionsLoading = state => state.trafficInfra.intersectionsLoading;
export const selectRetryCount = state => state.trafficInfra.retryCount;

export default trafficInfraSlice.reducer;
